"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOperationAssets = useOperationAssets;
const guide_content_1 = require("@guided-methods/guide-content");
const messaging_common_1 = require("@guided-methods/messaging-common");
const react_1 = require("react");
const react_2 = __importDefault(require("fast-deep-equal/react"));
const uuid = __importStar(require("uuid"));
function useOperationAssets(router, messageService, context, operations, rootChannelId) {
    if (!operations || operations.length === 0) {
        return { type: 'Ok', assets: [] };
    }
    const [assets, setAssets] = (0, react_1.useState)();
    const [error, setError] = (0, react_1.useState)();
    const operationsRef = (0, react_1.useRef)(operations);
    if (!(0, react_2.default)(operationsRef.current, operations)) {
        operationsRef.current = operations;
    }
    (0, react_1.useEffect)(() => {
        const responseChannelId = `${rootChannelId}/${uuid.v4()}`;
        const responseChannel = (0, messaging_common_1.createChannel)(guide_content_1.AssetsOperationsResponse, responseChannelId);
        const handler = router.subscribe(responseChannel, async (message) => {
            const onSuccess = (assets) => {
                setAssets(assets);
            };
            const onError = (error) => {
                setError({ error: error.error, errorMessage: error.errorMessage });
            };
            try {
                switch (message.type) {
                    case messaging_common_1.GuideMessageType.Data:
                        if (message.data.type === guide_content_1.GuideContentResponseType.Ok) {
                            onSuccess(message.data.assets);
                        }
                        else if (message.data.type === guide_content_1.GuideContentResponseType.Error) {
                            onError(message.data);
                        }
                        else {
                            onError({ error: 0, errorMessage: 'Unexpected response' });
                        }
                        break;
                    default:
                        onError({ error: 0, errorMessage: 'Unexpected response' });
                        break;
                }
            }
            catch (e) {
                onError({ error: 0, errorMessage: 'Unexpected response' });
            }
        });
        const operationsOfKnownContractTypes = operations.filter((o) => ['condition', 'measurement', 'custom'].find((t) => o.contractType.toLowerCase() === t.toLowerCase()));
        if (operationsOfKnownContractTypes.length > 0) {
            const operationIdentifiers = operationsOfKnownContractTypes.map((o) => ({
                ...o,
                contractType: o.contractType,
            }));
            const req = { operationIdentifiers, responseChannel };
            messageService.send(guide_content_1.assetsOperationsChannel, messaging_common_1.GuideMessageType.Data, context, req);
        }
        else {
            setAssets(assets);
        }
        return function cleanup() {
            router.unsubscribe(responseChannel, handler);
        };
    }, [operationsRef.current]);
    return assets
        ? { type: 'Ok', assets }
        : error !== undefined
            ? { type: 'Error', error }
            : { type: 'Pending' };
}
